import type { SearchkitWrapperProps } from '@uncinc/react-searchkit/dist/components/Wrapper';

export const searchAttributes: SearchkitWrapperProps['searchSettings']['search_attributes'] = [
  'title',
  'body',
  'kvk_number',
];

export const resultAttributes: SearchkitWrapperProps['searchSettings']['result_attributes'] = [
  'url',
  'title',
  'website',
  'postal_code',
  'address_line1',
  'address_locality',
  'telephone_number',
  'email',
];

export const facetAttributes: SearchkitWrapperProps['searchSettings']['facet_attributes'] = [
  {
    attribute: 'region_name',
    field: 'region_name',
    type: 'string',
    facetQuery: (
      field,
      size,
    ) => ({
      terms: {
        field,
        size,
        min_doc_count: 0,
      },
    }),
  },
  {
    attribute: 'sector_name',
    field: 'sector_name',
    type: 'string',
    facetQuery: (
      field,
      size,
    ) => ({
      terms: {
        field,
        size,
        min_doc_count: 0,
      },
    }),
  },
];

export const sorting: SearchkitWrapperProps['searchSettings']['sorting'] = {
  default: {
    field: '_score',
    order: 'desc',
  },
  _title: {
    field: 'sort_title',
    order: 'asc',
  },
};
